import { onDomReady } from '../utils/dom';
import { initElements, elements, state } from './config';
import { toggleMobileMenu, closeMobileMenu } from './mobile-menu';
import { initDropdown, hideNavbarDropdown } from './dropdown';
import { initSearch, openSearch, closeSearch } from './search';
import { initScroll } from './scroll';

declare global {
    interface Window {
        __mpHeaderInitialized?: boolean;
    }
}

function handleGlobalClick(e: Event): void {
    const target = e.target as HTMLElement;

    if (target.closest('.navbar-toggler')) {
        e.preventDefault();
        toggleMobileMenu();
        
        return;
    }

    if (target.closest('[data-close-submenu]')) {
        if (elements.mobileSidebar) {
            elements.mobileSidebar.classList.remove('opened-submenu');
        }
        hideNavbarDropdown();
        
        return;
    }

    const searchOpenBtn = target.closest('.search-landing-page_open') as HTMLElement | null;
    
    if (searchOpenBtn) {
        e.preventDefault();
        const isBlogSearch = searchOpenBtn.classList.contains('topic-badge');
        openSearch(isBlogSearch);
        
        return;
    }

    if (target.closest('.search-landing-page_close')) {
        e.preventDefault();
        closeSearch();
        
        return;
    }
}

function handleKeydown(e: KeyboardEvent): void {
    if (e.key === 'Escape') {
        if (state.isSearchOpen) {
            closeSearch();
        }
        
        if (state.isMobileMenuOpen) {
            closeMobileMenu();
        }
    }
}

// Guard against running twice. The production build can evaluate this entry's
// init more than once (e.g. multiple Vite entry bundles on the same page),
// which would bind the nav-link click/hover handlers twice — a tap then opens
// the submenu and the duplicate handler immediately closes it. The flag lives
// on `window` so it's shared across any duplicate module instances.
function init(): void {
    if (window.__mpHeaderInitialized) {
        return;
    }

    window.__mpHeaderInitialized = true;

    initElements();
    initDropdown();
    initSearch();
    initScroll();

    document.addEventListener('click', handleGlobalClick);
    document.addEventListener('keydown', handleKeydown);
}

onDomReady(init);

export {
    toggleMobileMenu,
    openSearch,
    closeSearch,
    hideNavbarDropdown
};